<template>
  <div>
    <label v-if="label" class="reason-label">
      {{ label }}
      <span v-if="hint" class="reason-hint">{{ hint }}</span>
    </label>
    <b-form-file
      :value="value"
      accept="application/pdf"
      placeholder="Choose a PDF or drop it here..."
      drop-placeholder="Drop PDF here..."
      size="sm"
      :state="value && !isValid ? false : null"
      @input="$emit('input', $event)"
    />
    <div v-if="value && !isValid" class="reason-error-msg">
      <feather-icon icon="AlertCircleIcon" size="12" class="mr-25" />
      File must be a PDF under {{ maxSizeMb }}MB.
    </div>

    <div v-if="previewUrl" class="pdf-preview">
      <div class="pdf-preview-toolbar">
        <span class="pdf-preview-name">
          <feather-icon icon="FileTextIcon" size="12" class="mr-25" />
          {{ value.name }} ({{ (value.size / 1024).toFixed(0) }} KB)
        </span>
        <div class="d-flex align-items-center" style="gap: 12px">
          <a :href="previewUrl" target="_blank" rel="noopener" class="pdf-preview-link">
            Open in new tab
          </a>
          <feather-icon
            icon="XIcon"
            size="14"
            class="cursor-pointer text-secondary"
            @click="$emit('input', null)"
          />
        </div>
      </div>
      <iframe :src="previewUrl" class="pdf-preview-frame" title="Attachment preview" />
    </div>
  </div>
</template>

<script>
import { BFormFile } from 'bootstrap-vue'
import {
    ref, computed, watch, onBeforeUnmount,
} from '@vue/composition-api'

export default {
    components: { BFormFile },
    props: {
        value: { type: File, default: null },
        label: { type: String, default: 'Attachment' },
        hint: { type: String, default: '(PDF, optional, max 8MB)' },
        maxSizeMb: { type: Number, default: 8 },
    },
    setup(props) {
        const previewUrl = ref(null)

        const isValid = computed(() => !props.value
            || (props.value.type === 'application/pdf' && props.value.size <= props.maxSizeMb * 1024 * 1024))

        watch(() => props.value, file => {
            if (previewUrl.value) {
                URL.revokeObjectURL(previewUrl.value)
                previewUrl.value = null
            }
            if (file && file.type === 'application/pdf') {
                previewUrl.value = URL.createObjectURL(file)
            }
        })

        onBeforeUnmount(() => {
            if (previewUrl.value) URL.revokeObjectURL(previewUrl.value)
        })

        return { previewUrl, isValid }
    },
}
</script>

<style lang="scss" scoped>
.reason-label {
  display: flex; align-items: center; gap: 4px;
  font-size: 12px; font-weight: 500; color: #5e5873; margin-bottom: 6px;
}
.reason-hint { font-size: 11px; font-weight: 400; color: #b9b9c3; }
.reason-error-msg {
  display: flex; align-items: center; gap: 4px;
  font-size: 11px; color: #a32d2d; margin-top: 5px;
}

.pdf-preview {
  margin-top: 10px;
  border: 0.5px solid #ebe9f1; border-radius: 8px; overflow: hidden;

  .pdf-preview-toolbar {
    display: flex; align-items: center; justify-content: space-between;
    padding: 6px 10px; background: #fafafa; border-bottom: 0.5px solid #ebe9f1;
  }
  .pdf-preview-name { font-size: 11px; color: #5e5873; display: flex; align-items: center; }
  .pdf-preview-link { font-size: 11px; color: #185fa5; }
  .pdf-preview-frame {
    width: 100%; height: 360px; border: none; display: block; background: #f4f4f4;
  }
}
</style>
